// extracted by mini-css-extract-plugin
export default {"border":"mHkLm","a11yFocus":"_0IpOH","a11YFocus":"_0IpOH"};